/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: renmanyi
 * @LastEditTime: 2023-07-07 13:55:18
 * @Description:
 */
import LoginService from '../service/LoginService';
import Platform from '@/core/platform';
import BenefitService from '../service/BenefitService';
import User from '@/core/user';

export default class WechatApi {
  static initShareConfig() {
    const { hash = '' } = location || {};
    if (hash.includes('#/venuePay')) {
      return
    }
    if (hash.includes('aiFamilyPay')) {
      return
    }
    if (Platform.isWeiXin()) {
      if (!User.appId() || User.appId() === 'null') {
        return
      }
      LoginService.getWechatAuthConfig().then(result => {
        const res = result.result;
        window.LS.setItem('xiaomai_appid', res.appId);
        wx.config({
          debug: false,
          appId: User.appId() || res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: [
            'onMenuShareAppMessage',
            'scanQRCode',
            'onMenuShareTimeline',
            'previewImage',
            'openLocation',
            'addCard',
            'openCard',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'hideMenuItems',
            'showMenuItems',
          ],
          openTagList: ['wx-open-subscribe'],
        });
      });
    }
  }

  // 图片预览
  static previewImages(current, urls) {
    if (Platform.isWeiXin()) {
      wx.ready(() => {
        wx.previewImage({
          current: current,
          urls: urls,
        });
      });
    }
  }

  // 分享
  static doWapShare(share, flag = false) {
    if (Platform.isWeiXin()) {
      share.desc = share.desc && share.desc.substr(0, 30);
      if (!flag) {
        share.imgUrl += '?x-oss-process=image/resize,w_270,limit_0';
      }
      wx.ready(() => {
        console.log('desc', wx);
        wx.onMenuShareTimeline({
          title: share.title,
          link: share.linkUrl, // 分享链接
          imgUrl: share.imgUrl, // 分享图标
          success: () => {
            // 用户确认分享后执行的回调函数
            console.log('已经分享了');
            // 有share函数再调用，兼容
            share.success ? share.success() : null;
          },
          cancel: () => {
            // 用户取消分享后执行的回调函数
            console.log('已经分享了cancel');
          },
        });
        console.log('share==========>', share);
        wx.onMenuShareAppMessage({
          title: share.title, // 分享标题
          desc: share.desc, // 分享描述
          link: share.linkUrl, // 分享链接
          imgUrl: share.imgUrl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: () => {
            // 用户确认分享后执行的回调函数
            // 有share函数再调用，兼容
            share.success ? share.success() : null;
            console.log('success');
          },
          cancel: () => {
            // 用户取消分享后执行的回调函数
            console.log('cancel');
          },
        });
      });
    }
  }


  // 查看地图
  static openLocation(res) {
    if (Platform.isWeiXin()) {
      wx.ready(() => {
        wx.openLocation({
          latitude: res.latitude, // 纬度，浮点数，范围为90 ~ -90
          longitude: res.longitude, // 经度，浮点数，范围为180 ~ -180。
          name: res.name, // 位置名
          address: '', // 地址详情说明
          scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
        });
      });
    }
  }

  static hideMenuItems() {
    if (Platform.isWeiXin()) {
      wx.hideAllNonBaseMenuItem();
    }
  }

  static hideMenuItems() {
    if (Platform.isWeiXin()) {
      wx.hideAllNonBaseMenuItem();
    }
  }

  static showMenuItems() {
    if (Platform.isWeiXin()) {
      wx.showAllNonBaseMenuItem();
    }
  }
  // 添加卡券
  static addCard(cardId, appId, copenId, couponId, studentPhone, studentName, referralId, promoterId, callback, studentCouponId) {
    if (Platform.isWeiXin()) {
      BenefitService.studentSignature(cardId).then(result => {
        const res = result.data;
        wx.addCard({
          cardList: [
            {
              cardId: cardId,
              cardExt: '{"nonce_str": "' + res.nonceStr + '", "timestamp": "' + res.timestamp + '", "signature":"' + res.signature + '"}',
            },
          ], // 需要添加的卡券列表
          success: function(res) {
            var cardList = res.cardList; // 添加的卡券列表信息
            const codeId = res.cardList[0].code;
            BenefitService.couponSaveCode(studentCouponId, codeId);
          },
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/wechatApi.js